module.exports = __webpack_public_path__ + "static/img/13.6159cd96.png";